import * as React from "react";
import { observer } from "mobx-react";
import { makeObservable } from "mobx";
import { CardBody } from "reactstrap";

import { BaseLoading } from "./BaseLoading";

type CardBodyLoadingProps = {
    className?: string;
    loading: boolean;
};

@observer
export class CardBodyLoading extends React.Component<CardBodyLoadingProps, {}> {

    constructor(props: CardBodyLoadingProps) {
        super(props);
        makeObservable(this);
    }

    render() {
        const { loading, className } = this.props;
        return (
            <CardBody className={className}>
                <BaseLoading loading={loading} fullpage={false} small />
            </CardBody>
        );
    }
}